module.exports = __webpack_public_path__ + "img/gesture_one.ad9c217b.png";